import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const t = useTheme();
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [bookings, setBookings] = useState([]);
  useEffect(() => { if (user) api.get("/bookings/me").then(r => setBookings(r.data)).catch(() => {}); }, [user]);
  useEffect(() => { if (!loading && !user) nav(`/auth`); }, [loading, user]);
  if (!user) return null;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-testid="dashboard-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>My Account</div>
          <h1 className="mt-3 text-5xl" style={{ color: t.text }}>Hello, {user.name?.split(' ')[0] || 'guest'}</h1>
        </div>
        <button onClick={async () => { await logout(); nav(`/`); }} className={`px-5 py-2 text-xs tracking-[0.2em] uppercase ${t.btnOutline}`} data-testid="dashboard-logout">Sign out</button>
      </div>
      <div className="mt-12 grid md:grid-cols-3 gap-8">
        <div className={`p-6 bg-white border ${t.accentBorder} md:col-span-2`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
          <h2 className="text-2xl" style={{ color: t.text }}>Upcoming Appointments</h2>
          {bookings.length === 0 ? (
            <div className="mt-6 text-sm opacity-75" data-testid="dashboard-no-bookings">No bookings yet. <Link to={`/booking`} className="underline">Book your first visit →</Link></div>
          ) : (
            <ul className="mt-6 divide-y" data-testid="dashboard-bookings-list">
              {bookings.map(b => (
                <li key={b.id} className="py-4 flex justify-between items-baseline">
                  <div><div className="text-lg">{b.service_name}</div><div className="text-xs opacity-70">{b.stylist_name}</div></div>
                  <div className="text-sm">{b.date} · {b.time}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={`p-6 bg-white border ${t.accentBorder}`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
          <h2 className="text-2xl" style={{ color: t.text }}>Saved Details</h2>
          <ul className="mt-4 text-sm space-y-1 opacity-90">
            <li>{user.name}</li><li>{user.email}</li><li>{user.phone || '—'}</li>
          </ul>
          <h3 className="mt-8 text-xl" style={{ color: t.text }}>My Courses</h3>
          <p className="mt-2 text-sm opacity-70" data-testid="dashboard-courses-empty">Once you enroll, your courses appear here.</p>
        </div>
      </div>
    </div>
  );
}
